import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { dashboardService, type OmsResourcesRange } from '../../../../services/dashboardService';

const REFRESH_MS = 5 * 60 * 1000;

/**
 * Single consolidated fetch for the OMS Operations Dashboard.
 * Keyed by range so today/week/month/all snapshots cache independently.
 */
export function useOmsOverview(range: OmsResourcesRange) {
  return useQuery({
    queryKey: ['oms-overview', range],
    queryFn: () => dashboardService.getOmsOverview(range),
    staleTime: REFRESH_MS,
    refetchInterval: REFRESH_MS,
    placeholderData: keepPreviousData,
  });
}
